import { graphql, fetchQuery, type Environment } from 'react-relay';

import { type refreshSfChatTokenQuery } from './__generated__/refreshSfChatTokenQuery.graphql.ts';

const query = graphql`
    query refreshSfChatTokenQuery(
        $userId: String!
        $sellerId: String!
        $hasUserId: Boolean!
        $hasSellerId: Boolean!
    ) {
        viewer {
            user(userId: $userId) @include(if: $hasUserId) {
                sfChatToken
            }
            seller(sellerId: $sellerId) @include(if: $hasSellerId) {
                sfChatToken
            }
        }
    }
`;

type EndUserIds =
    | { userId: string; sellerId?: undefined }
    | { userId?: undefined; sellerId: string };

async function refreshSfChatToken({
    environment,
    userId,
    sellerId,
}: { environment: Environment } & EndUserIds): Promise<string | null> {
    if (userId && sellerId) {
        return null;
    }

    if (!userId && !sellerId) {
        return null;
    }

    try {
        const data = await fetchQuery<refreshSfChatTokenQuery>(environment, query, {
            userId: userId ?? '',
            sellerId: sellerId ?? '',
            hasUserId: !!userId,
            hasSellerId: !!sellerId,
        }).toPromise();

        const { user, seller } = data?.viewer || {};
        const endUser = userId ? user : seller;

        return endUser?.sfChatToken || null;
    } catch {
        return null;
    }
}

export { refreshSfChatToken };
